import { useEffect, useState } from "react";
import Socials from "../ghana/socials";

import { Link, NavLink } from "react-router-dom";

const Nav = () => {
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop + 10) {
        // Scrolling down, hide navbar
        setShowNavbar(false);
      } else if (currentScroll < lastScrollTop - 10) {
        // Scrolling up, show navbar
        setShowNavbar(true);
      }

      setLastScrollTop(currentScroll <= 0 ? 0 : currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollTop]);

  const Mlinks = ["HOME", "FAQ", "HOW TO PLAY?"];

  let [open, setOpen] = useState(false);
  const Links = [
    { name: /*"HOME"*/"ACCUEIL", link: "/" }, // Home link
    { name: /*"PRIZES"*/"GAINS", link: "/prizes" },
    { name: /*"WINNERS"*/"GAGNANTS", link: "/winners" },
    { name: /*"HOW TO PLAY?"*/"COMMENT JOUER ?", link: "/howtoplay" }, // How to Play link
    { name: "FAQ", link: "/faq" },
  ];

  const mobileLinks = Links.slice(0, 3);

  return (
    <div
      className={`font-body w-full fixed top-0 left-0 z-10 ${
        showNavbar ? "md:translate-y-0" : "md:-translate-y-full "
      }  bg-gradient-to-r from-[#027CFB] to-[#000000]  md:bg-transparent`}
    >
      <div>
        <div className="md:flex mx-2 my-0 md:m-0 items-center justify-between  rounded-lg md:rounded-t-none">
          <div className="flex flex-shrink-0 items-center py-0 lg rounded-b-lg cursor-pointer md:px-8 px-5 ">
            <Link to="/">
              <img
                src="Mvuama-logo.png"
                alt="Mvuama bet Logo"
                className={`z-20 w-14 md:w-19 mr-1 ${open ? "hidden" : ""}`}
              />
            </Link>
          </div>

          {/* <div>
          <ul className="flex justify-between">
            
              {Links.map(link=> <li className="text-white">
                {Mlinks===link.name?link.name:""}
              </li>)}
            
          </ul>
        </div> */}

          <div
            onClick={() => setOpen(!open)}
            className="text-3xl absolute right-6 top-3 cursor-pointer md:hidden z-10"
          >
            <ion-icon name={open ? "close-outline" : "menu-outline"}></ion-icon>
          </div>

          <>
            <ul
              className={` md:flex text-center md:items-center md:pb-0  absolute md:static   md:z-auto z-[-1] left-0 top-0 w-full md:w-auto md:pl-0 md:mr-6 transition-all duration-500 ease-in ${
                open ? "opacity-100 bg-gradient-to-r from-[#027CFB] to-[#000000]" : "top-[-490px]"
              } md:opacity-100  opacity-95 whitespace-nowrap`}
            >
              {Links.map((link) => (
                <>
                  <li
                    key={link.name}
                    className="md:ml-8 font-semibold text-[15px] md:mx-5 md:my-0 my-7"
                  >
                    <NavLink
                      to={link.link}
                      className={({ isActive }) =>
                        isActive
                          ? "text-yellow-500 underline decoration-dashed"
                          : "text-white hover:text-amber-700 duration-200"
                      }
                      onClick={() => setOpen(false)}
                    >
                      {link.name}
                    </NavLink>
                  </li>
                </>
              ))}

              <Socials />
            </ul>

            <ul
              className={`${
                open ? "hidden" : "flex"
              } flex md:hidden md:hiden text-center   items-center w-full absolute top-5     justify-center text-xs text-white gap-4`}
            >
              {mobileLinks.map((Mlink, i) => (
                <li>
                  <NavLink
                    to={Mlink.link}
                    className={({ isActive }) =>
                      isActive
                        ? "text-yellow-500 underline decoration-dashed"
                        : "text-white hover:text-amber-700 duration-200"
                    }
                  >
                    {Mlink.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </>
        </div>
      </div>
    </div>
  );
};

export default Nav;
